export const dictionaryErrors = { TIPODESX: "Nombre del Tipo", TIPOPATH: "Nombre del Path" };
